/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import fullRelativeTime from 'embercom/lib/full-relative-time';

export default buildHelper(function (params) {
  return fullRelativeTime(params[0]);
});
